<template>
  <div id="logged-out-layout">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "LoggedOutLayout"
};
</script>
<style lang="scss" scoped>
#logged-out-layout {
  height: 100vh;
  width: 100vw;
}
</style>
